import { gql } from '@apollo/client';

export const UPDATE_PROPERTY_IN_INCIDENT_ALL_FIELDS = gql`
  mutation addOrUpdatePropertyInIncident($input: AddOrUpdatePropertyInIncidentInput!) {
    addOrUpdatePropertyInIncident(input: $input) {
      clientMutationId
      errors
      incidentUuid
      propertyUuid
      property {
        id
        propertyCode {
          id
          name
        }
        quantity
        unitMeasureType {
          id
          name
        }
        ibrPropertyDescription {
          id
          name
        }
        make
        description
        tagNumber
        serialNumber
        owner {
          id
          personalAttribute {
            id
            firstName
            lastName
            middleName
          }
        }
        ownerNotified
        value
        ibrSuspectedDrugType {
          id
          name
        }
        colorType {
          id
          name
        }
        location {
          id
          city
          state
          streetName
          streetNumber
          unit
          name
          zip
        }
        action {
          id
          name
        }
        taggedAt
        taggedBy {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
          deptAttribute {
            id
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
        }
        tempEvidenceLocationType {
          id
          name
        }
        nibrsRelated
        disposed
        tempEvidence
        incidentOffenses {
          id
          offenseViolationPrototype {
            id
            fullName
            name
            yoe
          }
          suspectVictimAffiliations {
            id
            suspect {
              id
              personalAttribute {
                id
                dob
              }
            }
          }
        }
        vehicle {
          id
          vehicleMake {
            id
            name
          }
          vehicleModel {
            id
            name
          }
          vehiclePlate {
            id
            name
          }
          validVehicleAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            vehicle {
              id
            }
          }
        }
        custodyChains {
          id
          fromOfficer {
            id
            personalAttribute {
              id
              firstName
              lastName
            }
            deptAttribute {
              badge
              id
              ori {
                id
                oriName
                abbreviation
              }
            }
          }
          custodyChainLocationType {
            id
            name
            oriId
            position
          }
          custodyChainSubLocationType {
            id
            name
            oriId
            position
          }
          evidenceLocationSubLocation {
            id
            location
            subLocation
          }
          evidenceLocationLocation {
            id
            location
          }
          remarks
          transferredAt
          officer {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                oriName
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
        labAnalysisInstances {
          id
          analysisPerformedBy {
            id
            name
            oriId
            position
          }
          analysisRequestType {
            id
            name
            oriId
            position
          }
          narrative
        }
      }
    }
  }
`